import React, {useEffect, useRef} from 'react';
import {useGridApiRef} from '@mui/x-data-grid-pro';
import type {OverviewTask} from 'services/tasks/types';
import {useLocalization} from 'localization';
import {CodeListsGate} from 'services/codelists';
import {useDataGridSettings} from 'services/settings/hooks';
import {resetToFirstPage} from 'components/dataTable';
import {SearchInput} from 'components/dataTable/components';
import {Table, useSchemaCodelistIds} from 'schema';
import {taskSchema} from 'schemas';
import {overviewTaskTableConfig} from 'schemas/configurations/table/overviewTaskTableConfig';
import {useOverviewContext} from '../context/OverviewContext';

const sx = {
  float: 'left',
  minWidth: '350px',
};

export const TaskTable: React.FC = () => {
  const {t} = useLocalization();
  const {
    loading,
    filteredTasks,
    openManifestation,
    searchText,
    setSearchText,
    onRowsUpdate,
    selectedTaskType,
  } = useOverviewContext();

  const schemaCodelistIds = useSchemaCodelistIds(taskSchema);

  const apiRef = useGridApiRef();
  const {initialState, saveState} = useDataGridSettings(taskSchema.name, {
    storeSize: true,
    storePage: true,
    storeSorting: true,
    storeFilter: true,
  });

  const taskTypeRef = useRef(selectedTaskType);
  useEffect(() => {
    if (taskTypeRef.current !== selectedTaskType) {
      taskTypeRef.current = selectedTaskType;
      resetToFirstPage(apiRef);
    }
  }, [apiRef, selectedTaskType]);

  return (
    <CodeListsGate codeLists={schemaCodelistIds}>
      <SearchInput
        value={searchText || ''}
        onChange={setSearchText}
        placeholder={t('page.overview.search.placeholder')}
        sx={sx}
      />
      <Table<OverviewTask>
        header={t('page.overview.tasks.today')}
        schema={taskSchema}
        data={filteredTasks}
        loading={loading}
        onRowClick={openManifestation}
        configuration={overviewTaskTableConfig}
        onRowsUpdate={onRowsUpdate}
        apiRef={apiRef}
        initialState={initialState}
        onSaveState={saveState}
      />
    </CodeListsGate>
  );
};
